import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    data: BannerWithFullImage
};

const Text: React.FC<Props> = ({ data }) => {
    const theme: Theme = useTheme();

    const colourTheme = JSON.parse(data.theme);
    const { headerColour } = colourTheme;

    const style = css`
        margin-top: 40px;
        white-space: pre-line;
        color: ${data.textColour || headerColour};
        font-size: 19px;
        line-height: 35px;
        font-weight: ${theme.fonts.weights.light};

        ${theme.breakpoints.down("sm")} {
            margin-top: 20px;
            font-size: 16px;
            line-height: 25px;
        }
    `;


    return data.text ? (
        <p css={style}>{data.text}</p>
    ) : null;
}

export default Text;
